import { render, staticRenderFns } from "./registerLocation.vue?vue&type=template&id=666f6948&scoped=true"
import script from "./registerLocation.vue?vue&type=script&lang=js"
export * from "./registerLocation.vue?vue&type=script&lang=js"
import style0 from "./registerLocation.vue?vue&type=style&index=0&id=666f6948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f6948",
  null
  
)

export default component.exports